export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Electricians, maintenance and instrumentation technicians, plant and reliability staff, commissioning technicians, electrical and mechanical engineers, and students who work with industrial motors and drives or want to.',
  ],
  [
    'Content depth?',
    'From fundamentals to advanced field practice: each volume is a visual technical reference with diagrams, comparison tables and practical takeaways.',
  ],
  [
    'International?',
    'Yes. The content is written in English for a global audience and covers both IEC and NEMA practices in general, brand-neutral terms.',
  ],
  ['Format?', 'Downloadable PDF files you can read on your phone, tablet or computer, or print.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
